import { IMAGES } from "../constants/config";

export const founderContent = {
  title: "Notre histoire",
  subtitle:
    "Crush Emploi est née de plus de dix ans d'accompagnement de jeunes en insertion professionnelle.",
  name: "Selma Rovini",
  role: "Fondatrice de Crush Emploi · Coach en insertion professionnelle",
  image: IMAGES.photos.founder,
  imageAlt: "Selma Rovini, fondatrice de Crush Emploi",
  bio: "Coach en insertion professionnelle, conférencière spécialisée en aide à l'embauche et experte en art oratoire, Selma se consacre à l'accompagnement des jeunes adultes. Grâce à sa pratique de développement professionnel, elle aide les personnes et les équipes à découvrir leur potentiel et à développer leurs compétences non techniques pour atteindre des objectifs professionnels.",
  pillars: [
    {
      icon: "coaching",
      title: "Expertise insertion",
      description:
        "Accompagnement de jeunes en recherche d'emploi, de stage ou d'alternance, au quotidien.",
    },
    {
      icon: "speech",
      title: "Soft skills & communication",
      description:
        "Art oratoire, confiance en soi et expression — le cœur de la candidature vidéo.",
    },
    {
      icon: "experience",
      title: "Engagement de long terme",
      description:
        "Structure SR Impact active depuis 2014, ancrée dans l'insertion et la jeunesse.",
    },
  ],
};

export function getFounderContent() {
  return founderContent;
}
